import { Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import dayjs from "@/utils/datetime"

export const weekdayValues = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"] as const

export function WeekDaySelect(props: SelectProps) {
  const { t } = useTranslation()

  const weekdays = weekdayValues.map((_, index) => ({
    value: String(index + 1),
    label: dayjs("2024-01-01").add(index, "day").format("dddd"),
  }))

  return <Select allowDeselect={false} label={t("Day of week")} data={weekdays} {...props} />
}
